<template>
  <div class="index_main">
    <div class="index_top">
      <div class="choose_type">
        <div>
          <span class="choose_label">单位名称：</span>
          <a-tree-select v-model:value="checkType.companyId" style="width: 250px" placeholder="请选择单位"
            :treeExpandedKeys="treeExpandedKeys" :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :tree-data="companyTreeData" :field-names="{ children: 'childList', label: 'regionName', value: 'key' }"
            @change="changeCompany" @treeExpand="expendTree">
          </a-tree-select>
        </div>
        <div>
          <span class="choose_label">变电站名称：</span>
          <a-select v-model:value="checkType.substation" style="width: 250px" :options="substations"
            :field-names="{ label: 'substationName', value: 'substationId' }" @change="changeSubstation"></a-select>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="info">
        <div class="info_left">
          <div class="info_item">
            <img src="@/style/img/time.png" alt="" class="head_icon">
            <span class="head_text">监测时间：<span class="info_text">{{ quary.time }}</span>天</span>
          </div>
          <div class="fenge">
            <img src="@/style/img/分隔.png" alt="">
          </div>
          <div class="info_item">
            <img src="@/style/img/number.png" alt="" class="head_icon">
            <span class="head_text">监测隔刀数量：<span class="info_text">{{ quary.switchNumber }}</span>台</span>
          </div>
          <div class="fenge">
            <img src="@/style/img/分隔.png" alt="">
          </div>
          <div class="info_item">
            <img src="@/style/img/bug.png" alt="" class="head_icon">
            <span class="head_text">缺陷次数：<span class="info_text">{{ quary.bugCount }}</span>次</span>
          </div>
        </div>
        <div class="info_right">
          <a-button class="btn" @click="readData">读取数据</a-button>
          <a-button class="btn" @click="showLayOut">终端安装布置图</a-button>
          <a-button class="btn" @click="showAllotWindow">下发图片</a-button>
        </div>
        <img src="@/style/img/lefttop.png" alt="" class="info_lt">
        <img src="@/style/img/leftbottom.png" alt="" class="info_lb">
        <img src="@/style/img/righttop.png" alt="" class="info_rt">
        <img src="@/style/img/rightbottom.png" alt="" class="info_rb">
      </div>
    </div>
    <div class="bottom_content">
      <div class="content_sider">
        <div class="content_left">
          <a-input-search placeholder="请输入过滤查找" @change="searchData" v-model:value="searchText">
            <template #prefix>
              <img src="@/style/img/搜索.png" />
            </template>
          </a-input-search>
          <a-tree :auto-expand-parent="autoExpandParent" :tree-data="dataSource1" :expanded-keys="expandedKeys"
            v-model:checkedKeys="checkedKeys" @expand="onExpand" @check="selectItem" checkable>
            <template #title="{ title, key, children }">
              <span
                v-if="title.toLowerCase().indexOf(searchText.toLowerCase()) > -1 && searchText.length != 0 && searchText">
                {{ title.substr(0, title.toLowerCase().indexOf(searchText.toLowerCase())) }}
                <span
                  style="color: #f50">{{ title.substr(title.toLowerCase().indexOf(searchText.toLowerCase()), searchText.length) }}</span>
                {{ title.substr(title.toLowerCase().indexOf(searchText.toLowerCase()) + searchText.length) }}
              </span>
              <span v-else>{{ title }}</span>
              <template v-if="key.split('&')[0] == site.substation">
                <img src="@/style/img/刷新.png" @click="reflashTree" class="statusIcon" />
              </template>
              <template v-if="children.length == 0 || !children">
                <span v-for="item in onlineStatus" :key="item.id">
                  <img v-if="item.id == key.split('&')[0] && item.status && item.status == 1" src="@/style/img/在线.png"
                    class="statusIcon" />
                  <img v-else-if="item.id == key.split('&')[0] && item.status && item.status == 2"
                    src="@/style/img/离线.png" class="statusIcon" />
                </span>
              </template>
            </template>
          </a-tree>
        </div>
      </div>
      <div class="main_content">
        <div class="content_right" ref="content">
          <div class="time_query">
            <span class="query_text">动作时间</span>
            <a-range-picker show-time v-model:value="activeTime" @change="changeRange" @resizeColumn="resizeTable" />
            <a-button class="btn" style="padding:0 23px 0 23px;margin-left: 10px;" @click="serachTableData">查询</a-button>
          </div>
          <div style="position:relative;flex : 1">
            <a-table ref="tableContent" :dataSource="dataSource2" :columns="columns2" :pagination="pagination"
              :scroll="{ y: heightWidth }" @change="changePage" :row-class-name='rowClassName'
              @resizeColumn="resizeTable">
              <template v-slot:bodyCell="{ record, column, index }">
                <template v-if="column.dataIndex == 'gdzt'">
                  <img v-if="record.gdzt && record.gdzt.includes('正常')" src="@/style/img/正常-03.png" />
                  <img v-else-if="record.gdzt && record.gdzt.includes('一般缺陷')" src="@/style/img/一般缺陷.png" />
                  <img v-else-if="record.gdzt && record.gdzt.includes('严重缺陷')" src="@/style/img/严重缺陷.png" />
                  <img v-else-if="record.gdzt && record.gdzt.includes('故障')" src="@/style/img/故障.png" />
                  <span v-else></span>
                </template>
                <template v-if="column.dataIndex == 'zdzt'">
                  <img v-if="record.zdzt == 1" src="@/style/img/在线.png" />
                  <img v-else-if="record.zdzt == 2" src="@/style/img/离线.png" />
                  <img v-else-if="record.zdzt == 3" src="@/style/img/故障状态.png" />
                  <span v-else></span>
                </template>
                <template v-if="column.dataIndex == 'glqx'">
                  <a-checkbox-group :options="[record.key]" @change="showList" v-model:value="checkItem[index]">
                  </a-checkbox-group>
                </template>
                <template v-if="column.dataIndex == 'sjbg'">
                  <img src="@/style/img/报告.png" @click="showDocument(record.key)" class="reportPhoto" title="查看数据报告"
                    style="height:19px;cursor:pointer;" />
                </template>
              </template>
              <template #operation="{ record }">
                <a @click="cs(record)">删除</a>
              </template>
            </a-table>
            <div class="status_icon">
              <span>机械状态：</span>
              <span style="margin-right:16px;vertical-align:middle"><img src="@/style/img/正常-03.png"
                  style="margin-right:4px" alt="">正常</span>
              <span style="margin-right:16px;vertical-align:middle"><img src="@/style/img/一般缺陷.png"
                  style="margin-right:4px" alt="">一般缺陷</span>
              <span style="margin-right:16px;vertical-align:middle"><img src="@/style/img/严重缺陷.png"
                  style="margin-right:4px" alt="">严重缺陷</span>
              <span style="margin-right:16px;vertical-align:middle"><img src="@/style/img/故障.png" alt=""
                  style="margin-right:4px">故障</span>
              <a-button class="btn2" @click="getChartData">绘制功率曲线</a-button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showLayoutPicture">
        <div class="showPicture">
          <div class="layout_main">
            <div class="layout_head">终端安装布置图</div>
            <div class="layout_picture">
              <router-link :to="{ path: '/photoPreview.html', query: { imgURL: `${imgURL}` } }" target="_blank">
                <img :src="imgURL" class="pictureStyle" />
              </router-link>
            </div>
          </div>
          <img src="@/style/img/关闭.png" class="close" @click="closeLayoutPicture">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div class="chart_bg" @click="closeLayoutPicture"></div>
      </div>
      <div v-if="isShowPhoto">
        <div class="chartPhoto" ref="chartPhoto">
          <div class="chart_head">隔离/接地开关动作曲线图</div>
          <div id="chart" class="chartStyle"></div>
          <img src="@/style/img/关闭.png" class="close" @click="closeChart">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div class="chart_bg" @click="closeChart"></div>
      </div>
      <div v-if="showAllotPicture">
        <div class="showPicture" style="width:40%">
          <div class="layout_main">
            <div class="layout_head">下发图片</div>
            <div class="layout_picture">
              <div style="width:100%">
                <div style="width:100%">
                <span style="color:#fff;font-size:14px;">client id：</span>
                <a-select
                  v-model:value="clientID"
                  style="width:200px;margin-right:20px;"
                  :options="clients"
                  @change="changeClientID"
                />
                <span style="color:#fff;font-size:14px;">服务类型：</span>
                <a-input 
                  v-model:value="serveType" 
                  disabled="true" 
                  class="serveStyle"
                  style="width:200px;margin-right:20px;height:27px;"
                  placeholder="选择clientID后自动添加"
                  >
                </a-input>
                <a-button style="height:29px;" @click="reflashSend">刷新</a-button>
              </div>
              <div style="width:100%;margin:20px 0;">
                <span style="color:#fff;font-size:14px;">终端安装布置图：</span>
                <a-upload
                    name="file"
                   :customRequest="sureHandle"
                  >
                  <span style="color:#59fddf;font-size:16px;cursor:pointer;margin-right:20px;" title="点击上传图片">{{InstallDiagramStaus == '1' ? "下发中" : InstallDiagramStaus == '2' ? '下发失败' : InstallDiagramStaus == '3' ? '下发成功' : '--' }}</span>
                </a-upload>
                <span style="color:#fff;font-size:14px;" >终端安装图(已下发/终端总数)：</span>
                <!-- multiple -->
                <a-upload
                    name="file"
                   :customRequest="sureHandle2"
                   :beforeUpload="beforeUpload"
                   multiple="true"
                  >
                  <!--  -->
                  <span style="color:#59fddf;font-size:16px;cursor:pointer" title="点击上传图片">{{sendSuccessNum}}/{{totalSend}}</span>
                </a-upload>
              </div>
              <a-table ref="tableContent" :dataSource="dataSource3" :columns="columns3" class="tableStyle"
              :scroll="{ y: heightWidth }" @change="changePage" :pagination="false" bordered
              @resizeColumn="resizeTable">
                <template v-slot:bodyCell="{ record, column }">
                  <template v-if="column.dataIndex == 'photoStatus'">
                    <span v-if="record.photoStatus == 3" style="cursor:pointer;color:#59fddf;margin-right:10px;" @click="showPhotoOne(record,$event)">查看</span>
                    <a-upload
                      name="file"
                     :customRequest="sureHandle3"
                    >
                      <span v-if="record.photoStatus == 1" style="cursor:pointer;color:#59fddf;">下发中</span>
                      <span v-else-if="record.photoStatus == 2" style="cursor:pointer;color:#59fddf;">下发失败</span>
                      <span v-else-if="record.photoStatus == 3" style="cursor:pointer;color:#59fddf;">下发成功</span>
                      <span v-else style="cursor:pointer;color:#59fddf;">--</span>
                    </a-upload>
                  </template>
                </template>
              </a-table>
              </div>
            </div>
          </div>
          <img src="@/style/img/关闭.png" class="close" @click="closeAllotWindow">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        <div class="chart_bg" @click="closeAllotWindow"></div>
      </div>
      <div v-if="isShowPhotoOne">
        <div class="showPicture" style="width:45%">
          <div class="layout_main">
          <div class="layout_head">安装布置图</div>
          <div class="layout_picture">
            <img :src="photoOneURL" class="pictureStyle" />
          </div>
          <img src="@/style/img/关闭.png" class="close" @click="closePhotoOne">
          <img src="@/style/img/左上.png" alt="" class="info_lt" style="top:-1px ;left:-1px">
          <img src="@/style/img/左下.png" alt="" class="info_lb" style="bottom:-1px ;left:-1px">
          <img src="@/style/img/右上.png" alt="" class="info_rt" style="top:-1px ;right:-1px">
          <img src="@/style/img/右下.png" alt="" class="info_rb" style="bottom:-1px ;right:-1px">
        </div>
        </div>
        
        <div class="chart_bg"></div>
      </div>
    </div>
    <div class="footer">
      <div>
        <span style="margin-right: 10px;">
          <!-- 端口号：{{portId}} -->
        </span>
        <span>
          <!-- 通信状态：{{communicationStatus}} -->
        </span>
      </div>
      <div>
        技术咨询电话： 180&nbsp;6263&nbsp;5018
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import dayjs from 'dayjs'
import config from '@/utils/config'
import { uuid } from "vue-uuid";//让文件名唯一
import {
  // siteInfo,
  getWatchTime,
  getSwitchCount,
  getDefectCount,
  getPageList,
  getLayOut,
  excelImport,
  powerCurve,
  getReport,
  updataSiteInfo,
  findReport,
  getCompanyMenu,
  getSubstationOptionByCompany,
  getMenuList,
  getReadData,
  deleteDiagFile,
  clientIdOption,
  termInstallDiagramList,
  termInstallDeployDiagram,
  termInstallDiagramBatchDeploy,
  termInstallDeployDiagramStatus,
  getTerminalPhoto
} from '../../api/index'
export default {
  created() {
    //this.site.substation = JSON.parse(localStorage.getItem('userInfo')).substation
    this.companyInfo()
  },
  mounted() {
    this.token = localStorage.getItem("token") || ''
    this.getTime()
    this.onWidnowResize();
    window.addEventListener("resize", this.onWidnowResize, false);

  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onWidnowResize);
    // localStorage.clear();
  },
  data() {
    this.mychart = null
    return {
      token: '',
      rowSelection: [],
      site: { //站点信息
        name: '',
        substation: '',//站点id
      },
      quary: { //检测时间 数量 缺陷次数
        time: 0,
        switchNumber: 0,
        bugCount: 0,
      },
      showLayoutPicture: false,
      autoExpandParent: true,//父类自动展开
      expandedKeys: [],//需要展开的节点
      imgURL: '',
      onlineStatus: [],
      checkedKeys: [],//选中的key
      checkItem: [],//所有曲线的选项
      quxianList: [],//需要显示曲线的列表
      isShowPhoto: false,//是否显示曲线（弹出框）
      isLeave: false,//显示是否离开
      activeTime: [],//动作时间列表
      openStatus: false,//时间控件是否显示
      pagination: { //分页设置
        //  每条数量
        current: 1,
        total: '',
        pagesize: 10,
        // 可改变本页的条数
        pageSizeOptions: ['10', '20', '30', '50', '100'],
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total => `共${total}条`)
      },
      newTime: '',
      week: '',
      dataSource1: [],
      dataSource2: [],
      columns2: [
        {
          title: '间隔',
          dataIndex: 'jg',
          key: 'jg',
          sorter: {
            multiple: 3,
          },
          width: 350,
          minWidth: 350,
          maxWidth: 370,
          resizable: true,
          align: 'center',
        },
        {
          title: '开关编号',
          dataIndex: 'kgbh',
          key: 'kgbh',
          sorter: {
            multiple: 2,
          },
          width: 240,
          minWidth: 240,
          maxWidth: 270,
          resizable: true,
        },
        {
          title: '动作时间',
          dataIndex: 'dzsj',
          key: 'dzsj',
          sorter: {
            multiple: 1,
          },
          width: 150,
          resizable: true,
        },
        {
          title: '分合状态',
          dataIndex: 'fhzt',
          key: 'fhzt',
        },
        {
          title: '终端状态',
          dataIndex: 'zdzt',
          key: 'zdzt',
        },
        {
          title: '隔刀状态',
          dataIndex: 'gdzt',
          key: 'gdzt',
        },
        {
          title: '功率曲线',
          dataIndex: 'glqx',
          key: 'glqx',
        },
        {
          title: '数据报告',
          dataIndex: 'sjbg',
          key: 'sjbg',
        },
        {
          title: '删除报告',
          dataIndex: 'shanchu',
          slots: { customRender: 'operation' },
        }
      ],
      contBoxCodes: [],
      switchCodes: [],
      treeAllKey: [],
      treeList: [],
      newTreeList: [],
      treeData: [],//站点树的数据
      heightWidth: 100,
      searchText: '',
      sort: '',
      filterList: [],
      treeExpandedKeys: [],
      rate: 1,
      flashTime: null,
      colorList: ['#e6194B', '#3cb44b', "#ffe119", "#4363d8", '#f58231', '#911eb4', '#42d4f4', '#f032e6', '#bfef45', '#fabed4',
        '#469990', '#dcbeff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#a4d8a8', '#a64d79'],
      checkType: {
        company: null,
        companyId: null,
        city: null,
        province: null,
        substation: null,
      },
      substation: [],
      company: [],
      companyTreeData: [],
      substations: [],
      first: 1,
      showAllotPicture:false,
      clients:[],
      clientID:null,
      dataSource3:[],
      columns3:[{
          title: '终端id',
          dataIndex: 'communicationID',
          key: 'communicationID',
        },{
          title: '终端安装图',
          dataIndex: 'photoStatus',
          key: 'photoStatus',
        }],
      fileList : [],
      InstallDiagramStaus:'',
      totalSend : 0,
      successNum: 0,
      sendSuccessNum:0,
      isShowPhotoOne:false,
      photoOneURL:''
    }
  },
  methods: {
    showPhotoOne(record,e) {
      this.showTerminalPhoto(record)
    },
    showTerminalPhoto(record) {
      let query = {
        substation : this.clientSubstation,
        communicationID:record.communicationID
      }
      getTerminalPhoto(query).then(res => {
        let photo = new Blob([res], { type: 'image/jpeg' });
        this.photoOneURL = URL.createObjectURL(photo);
        this.isShowPhotoOne = true
      })
    },
    closePhotoOne(){
      this.isShowPhotoOne = false
    },
    changeClientID(e,node){
      this.clientID = e
      this.setServeType(node.serviceType)
      this.clientSubstation = node.substation
      this.reflashSend()
    },
    reflashSend() {
      this.queryDiagramPage()
      this.queryInstallDiagramStatus()
    },
    beforeUpload(file, fileList) {
      this.fileList.push(file)
      if(this.fileList.length == fileList.length) return true 
      else return false
    },
    sureHandle(e) { 
      if(e.file) this.uploadFile(1,e.file)
    },
    sureHandle2(e) {
      let form = new FormData();
      let formNames = []
      this.fileList.forEach(item => {
        form.append('uploadFiles',item)
        formNames.push(item.name)
      })
      this.uploadFile(2,form)
      this.fileList = []
    },
    sureHandle3(e) {
      let form = new FormData();
      form.append('uploadFiles',e.file)
      this.uploadFile(2,form)
    },
    //上传模板
    uploadFile(type,file) {
        if(type == 1) {
          let query = {
            uploadFile : file
          }
          termInstallDeployDiagram(this.clientID,query).then(res => {
            if(res.success) {
                this.$message.success(res.info)
                this.reflashSend()
            }else {
                this.$message.error(res.info)
            }
          }).catch(err => {
              this.$message.error("上传失败")
          })
        }
        else if(type ==2) {
          // let query = {
          //   uploadFiles : file
          // }
          termInstallDiagramBatchDeploy(this.clientID,file).then(res => {
            if(res.success) {
                this.$message.success(res.info)
                this.reflashSend()
            }else {
                this.$message.error(res.info)
            }
          }).catch(err => {
              this.$message.error("上传失败")
          })
        }
      },
    //获取clientID
    getClientID() {
      let query = {
        substationId:this.checkType.substation
      }
      clientIdOption(query).then(res => {
        this.clients = []
        this.clientID = null
        this.serveType = ''
        if(res.success) {
          let list = []
          if(res.data && res.data.length > 0) {
            res.data.forEach(item => {
              list.push({
                value:item.clientID,
                serviceType:item.serviceType,
                substation:item.substation
              })
            })
            this.clients = list
            this.clientID = list[0].value
            this.setServeType(list[0].serviceType)
            this.clientSubstation = list[0].substation
            this.reflashSend()
          }
          else {
            this.dataSource3 = []
            this.totalSend = 0
            this.sendSuccessNum = 0
            this.InstallDiagramStaus = '--'
          }
        }
      }).catch(err => {
        this.clients = []
        this.clientID = null
        this.serveType = ''
      })
    },
    setServeType(type) {
      type == 1 ? this.serveType = "站端" : type == 2 ? this.serveType == "便携端" : this.serveType = '--'
    },
    queryDiagramPage() {
      let query = {
        clientID : this.clientID
      }
      termInstallDiagramList(query).then(res => {
        this.dataSource3 = []
        this.totalSend = 0
        this.sendSuccessNum = 0
        if(res.success) {
          let list = []
          if(res.data &&  res.data.length > 0) {
            let total = 0
            let successNum = 0
            res.data.forEach((item,index) => {
              total++
              item.termInstallDiagramStatu == "3" && successNum++
              list.push({
                id:item.id || index,
                communicationID:item.termID,
                photoStatus:item.termInstallDiagramStatu 
              })
            })
            this.totalSend = total
            this.sendSuccessNum = successNum
          }
          this.dataSource3 = list
        }
      }).catch(err => {
        this.totalSend = 0
        this.sendSuccessNum = 0
        this.dataSource3 = []
      })
    },
    queryInstallDiagramStatus() {
      termInstallDeployDiagramStatus(this.clientID).then(res => {
        if(res.success) {
          this.InstallDiagramStaus = res.data || '--'
        }
      })
    },
    cs(row) {
      deleteDiagFile({ id: row.key }).then(res => {
        if (res.success) {
          this.$message.success(res.info);
        } else {
          this.$message.info(res.info);
        }
      })
    },
    //读取数据
    readData() {
      let query = {
        substationId: this.site.substation,
      }
      getReadData(query).then(res => {
        if (res.info == "操作成功") {
          this.getTableData()
        }
        this.$message.info(res.info);
      }).catch(err => {
        this.$message.error("操作失败");
      })
    },
    customRequest(info) {
      let form = new FormData();
      form.append('uploadFile', info.file);
      let query = {
        name: this.site.name,
        substation: this.site.substation
      }
      excelImport(query, form).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        if (res.success) {
          this.$message.info('上传成功')
        }
        else {
          this.$message.info(`${res.info}`);
        }
      }).catch((err) => {
        this.$message.info("上传失败");
        this.$message.info(err);
      });
    },
    companyInfo() {
      getCompanyMenu().then(res => {
        let tree = res.data
        tree.forEach(item => {
          item.key = item.regionCode + ""
          if (item.childList && item.childList.length > 0) {
            item.childList.forEach(data => {
              data.key = item.regionCode + "-" + data.regionCode
              if (data.childList && data.childList.length > 0) {
                data.childList.forEach(company => {
                  company.key = item.regionCode + "-" + data.regionCode + "-" + company.regionCode
                  if (this.first == 1) {
                    this.checkType.companyId = company.key
                    this.checkType.city = company.key.split('-')[1]
                    this.checkType.company = company.key.split('-')[2]
                    this.checkType.province = company.key.split('-')[0]
                    this.treeExpandedKeys.push(item.key, data.key, company.key)
                    this.first++
                  }

                })
              }
            })
          }
        })
        // console.log(tree)
        this.companyTreeData = tree

        this.checkSubstation()
      })
    },
    //单位名称切换
    changeCompany(value) {
      let values = value.split('-')
      this.checkType.province = values[0]
      this.checkType.city = values[1]
      this.checkType.company = values[2]
      this.checkType.companyId = value
      this.checkSubstation()
    },
    //展开
    expendTree(expandedKeys) {
      this.treeExpandedKeys = expandedKeys
    },
    //通过单位名称查询变电站名称
    checkSubstation() {
      let query = {
        city: this.checkType.city ? this.checkType.city : null,
        companyId: this.checkType.company ? this.checkType.company : null,
        province: this.checkType.province ? this.checkType.province : null
      }
      this.substations = []
      getSubstationOptionByCompany([query]).then(res => {
        if (res.data) {
          this.checkType.substation = null
          this.substations = res.data
          if (res.data.length > 0) {
            this.site.name = res.data[0].substationName
            this.site.substation = res.data[0].substationId
            this.checkType.substation = res.data[0].substationId
            this.reflash();
          }
        }
      })
    },
    //切换变电站
    changeSubstation(e, option) {
      this.site.name = option.substationName
      this.site.substation = option.substationId
      this.reflash()
    },
    updataSite() {
      updataSiteInfo({
        id: this.site.substation,
        name: this.site.name
      }).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        if (res.success && res) {
          this.getTree()
        }
      }).catch((err) => {
        this.$message.info(err);
      })
    },
    //拖拉table
    resizeTable(w, col) {
      col.width = w;
    },
    //文件下载
    showDocument(id) {
      findReport(id).then(res => {
        this.$message.info(res.info)
        clearTimeout(this.freshTime)
        this.freshTime = setTimeout(() => {
          this.getTableData()
          clearTimeout(this.freshTime)
        }, 3000)
        if (res.success) {
          let fileName = `${this.site.name}/${res.data}`;
          getReport(fileName).then(res => {
            if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
              localStorage.clear();
              this.$router.push({
                path: config.loginURL
              })
            }
            const url = URL.createObjectURL(res);
            const link = document.createElement('a');
            link.href = url;

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
          })
        }
      })
    },
    //排序或者换页时调用
    changePage(page, _, sort) {
      if (page.current != this.pagination.current || page.pageSize != this.pagination.pagesize) {
        this.pageChange(page.current, page.pageSize)
      }
      else {
        this.changeSort(sort);
      }
    },
    //换页清空选中的曲线、重新获取table值
    pageChange(current, pagesize) {
      this.pagination.current = current;
      this.pagination.pagesize = pagesize;
      this.getTableData();
      this.checkItem = [];
      this.quxianList = [];
    },
    //排序后，设置排序结构
    changeSort(sort) {
      let sortString = '';
      //存在多个(必然是全部选中)
      if (sort.length) {
        sortString = 'ORDER BY '
        for (let i = sort.length - 1; i >= 0; i--) {
          if (sort[i].field == 'jg') {
            sortString += `a.ContBoxEncrypt ${sort[i].order == 'descend' ? 'DESC' : ''}${i == 0 ? '' : ','}`;
          }
          else if (sort[i].field == 'kgbh') {
            sortString += `a.SwitchCode ${sort[i].order == 'descend' ? 'DESC' : ''}${i == 0 ? '' : ','}`;
          }
          else if (sort[i].field == 'dzsj') {
            sortString += `c.OperaTime ${sort[i].order == 'descend' ? 'DESC' : ''}${i == 0 ? '' : ','}`;
          }
        }
      }
      //存在一个
      else {
        //先判断是否排序，若没有排序，则说明全部没有选中
        if (!sort.order || sort.order == {}) {
          sortString = '';
        }
        else {
          sortString = 'ORDER BY '
          if (sort.field == 'jg') {
            sortString += `a.ContBoxEncrypt ${sort.order == 'descend' ? 'DESC' : ''}`;
          }
          else if (sort.field == 'kgbh') {
            sortString += `a.SwitchCode ${sort.order == 'descend' ? 'DESC' : ''}`;
          }
          else if (sort.field == 'dzsj') {
            sortString += `c.OperaTime ${sort.order == 'descend' ? 'DESC' : ''}`;
          }
        }
      }
      this.sort = sortString;
      this.getTableData();
    },
    //获取检测时间
    getWTime() {
      getWatchTime(this.site.substation).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        this.quary.time = res.data
      }).catch(() => {
        this.$message.info('检测时间获取失败');
      })
    },
    //获取检测的隔刀数量
    getSwitch() {
      getSwitchCount(this.site.substation).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        this.quary.switchNumber = res.data
      }).catch(() => {
        // console.log(err);
        this.$message.info("获取检测隔刀数量失败");
      });
    },
    //获取缺陷次数
    getDefect() {
      getDefectCount(this.site.substation).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        this.quary.bugCount = res.data
      }).catch(() => {
        // console.log(err);
        this.$message.info("获取缺陷次数失败");
      });
    },
    //获取装置图
    showLayOut() {
      getLayOut(this.site.name).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        let photo = new Blob([res], { type: 'image/jpeg' });
        this.imgURL = URL.createObjectURL(photo);
        this.showLayoutPicture = true;

      }).catch(() => {
        this.$message.error("获取安装布置图失败");
      });
    },
    //关闭弹出来的图片
    closeLayoutPicture() {
      this.showLayoutPicture = false
    },
    //显示下发图片窗口
    showAllotWindow() {
      this.showAllotPicture = true
      this.getClientID()
    },
    //关闭下发图片的窗口
    closeAllotWindow() {
      this.showAllotPicture = false
    },
    //导入
    upLoadChange(info) {
      // 文件上传成功
      // console.log(info.file.status)
      if (info.file.status === 'done') {
        //判断文件类型是否正确
        //1.获取文件信息
        let file = info.file.originFileObj;
        let fileName = info.file.name;
        //2.获取文件类型
        let suffix = '';
        //如果文件名不为空
        if (null != file.name) {
          suffix = fileName.substring(
            fileName.lastIndexOf('.') + 1,
            fileName.length
          )
        }
        //3.判断文件是否上传以及类型
        if (suffix == '') {
          this.$message.info('上传文件不能为空')
          return false;
        }
        if (suffix != 'xlsx' && suffix != 'xls') {
          this.$message.info('请选择正确的excel类型文件!');
          return false;
        }
        let form = new FormData();
        form.append('uploadFile', file);
        let query = {
          name: this.site.name,
          substation: this.site.substation
        }
      }

    },
    //更新按钮 
    reflash() {
      // this.getSiteInfo()
      this.getWTime()
      this.getSwitch()
      this.getDefect()
      this.getTree()
    },
    //数据扁平化
    getTreeInfo(treeData) {
      treeData.forEach(item => {
        item.key = item.key + '&' + uuid.v1()
        if (item.children.length == 0 || !item.children) {
          this.onlineStatus.push({
            id: item.key.split('&')[0],
            // status : item.mechaState,
            status: item.online
          })
        }
        this.expandedKeys.push(item.key);
        this.checkedKeys.push(item.key);
        this.treeList.push({
          key: item.key,
          title: item.title,
          parentId: item.parentId,
          children: item.children || [],
          termId: item.termId
        });
        if (item.children && item.children.length > 0) {
          this.getTreeInfo(item.children);
        }
      })

    },
    //获取tree数据
    getTree() {
      let query = {
        substationId: this.site.substation,
        substationName: this.site.name
      }

      getMenuList(query).then(res => {
        this.dataSource2 = []
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear()
          this.$router.push({
            path: config.loginURL
          })
        }
        //只有一个站点
        //设置独一无二的key
        //this.treeData = [res.data];
        //数据源（树）
        // this.checkedKeys = this.site.substation;
        //this.dataSource1 = [res.data];

        this.treeList = [];//扁平化处理后的结果
        this.onlineStatus = [];
        this.getTreeInfo([res.data]);//数据扁平化
        this.dataSource1 = [this.treeList[0]]
        this.treeData = [this.treeList[0]]
        //区分间隔和隔刀
        this.filterData(this.treeList, this.checkedKeys);
        //渲染表格
        this.getTableData();
      }).catch(() => {
        this.dataSource2 = []
        this.$message.error("获取表格数据失败");
      });
    },
    //筛选tree
    searchData(e) {
      this.checkedKeys = [];
      //  this.filterList = [];
      const value = e.target.value.toLowerCase();
      //展开节点
      const expandedKeys = this.treeList
        .map((item) => {
          if (item.title.toLowerCase().indexOf(value) > -1) {
            return this.getParentKey(item.key, this.treeData);
          }
          return null;
        })
        .filter((item, i, self) => item && self.indexOf(item) === i);
      // this.setDisplayStyle(this.treeData,value);
      //filterList通过输入值筛选的key值(可以显示的)
      // if(this.searchText == '') this.filterList = [];
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true,
      });
    },
    //可显示的tree值
    setDisplayStyle(treeData, value) {
      let nums = 0 //用于标识此某个父类的子类是否存在符合的
      for (let data of treeData) {
        let bl = false;
        if (data.title.toLowerCase().indexOf(value) > -1) {
          bl = true;
          nums += 1;
        }
        if (data.children) {
          //判断是否有子类
          if (data.children.length > 0) {
            let count = this.setDisplayStyle(data.children, value);
            nums += count;
            if (!bl && count == 0) {
              bl = false;
            } else {
              bl = true;
            }
          }
        }
        if (bl) {
          this.filterList.push(data.key);
          delete data['style'];
        }
        else {
          data['style'] = 'display : none'
        }
      }
      return nums;
    },
    getParentKey(key, tree) {
      let parentKey;
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i];
        if (node.children) {
          if (node.children.some((item) => item.key === key)) {
            parentKey = node.key;
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children);
          }
        }
      }
      return parentKey;
    },
    onExpand(keys) {
      this.expandedKeys = keys;
      this.autoExpandParent = false;
    },
    //退出界面
    leaveSystem() {
      localStorage.clear();
      this.$router.push({
        path: config.loginURL
      })
    },
    //显示退出界面的窗口
    leave() {
      this.isLeave = true;
    },
    //刷新树
    reflashTree() {
      this.searchText = '';
      this.dataSource1 = [];
      this.getTree()
    },
    //区分各个和隔刀
    filterData(allData, checkData) {
      this.contBoxCodes = []; //间隔
      this.switchCodes = [];  //隔刀
      let contBoxCodes = [];//间隔
      let switchCodes = []; //隔刀
      //区分隔刀还是间隔
      for (let i = 0; i < checkData.length; i++) {
        for (let j = 0; j < allData.length; j++) {
          //判断隔刀还是间隔
          if (checkData[i] == allData[j].key) {
            if (allData[j].key.split('&')[0] === this.site.substation) break;
            if (allData[j].parentId == this.site.substation) {
              contBoxCodes.push(allData[j].key);
              break;
            }
            if (allData[j].parentId && allData[j].parentId != this.site.substation) {
              switchCodes.push(allData[j].key);
              break
            }
          }
        }
      }
      //1.首先判断是否为间隔
      //2.判断此间隔是否存在隔刀（此列表）
      this.contBoxCodes = contBoxCodes;
      this.switchCodes = switchCodes;
      //   let needAddChidren = [];
      //   //获取所有间隔以及间隔的children
      //   if(this.filterList.length > 1 && this.filterList) {
      //   let filterContBox = allData.filter(item => contBoxCodes.indexOf(item.key) > -1)
      //   filterContBox.forEach(item => {
      //     if(item.children && item.children.length > 0) {
      //       let flag = false;
      //       item.children.forEach(data => {
      //         if(switchCodes.indexOf(data.key) > -1) {
      //          flag = true;
      //         }
      //       })
      //     if(flag == false)  needAddChidren.push(item.children);
      //     }
      //   })
      // }
      // needAddChidren.forEach(childrens => {
      //   childrens.forEach(item => {
      //     this.switchCodes.push(item.key);
      //   })
      // })
    },
    //选择的tree数据
    selectItem(e, node) {
      this.contBoxCodes = [];//间隔
      this.switchCodes = [];//隔刀
      let checkedList = [];
      //克隆
      e.forEach(item => {
        checkedList.push(item);
      })
      if (node.halfCheckedKeys.length > 0 && node.halfCheckedKeys) {
        node.halfCheckedKeys.forEach(item => {
          checkedList.push(item);
        })
      }
      this.checkedKeys = e;
      // if(this.filterList.length > 1) {
      //   //newList = > 只选择勾选的，存在有些值被隐藏但是勾选时还能再次选中，过滤这些值
      //  let newList = checkedList.filter(item => {
      //     if(this.filterList.indexOf(item) > -1) return true;
      //   })
      //   this.filterData(this.treeList,newList);
      // }
      // else {
      this.filterData(this.treeList, checkedList);
      // }  
    },
    //查询
    serachTableData() {
      this.pagination.current = 1;
      this.getTableData();
    },
    //获取table信息
    getTableData() {
      let query;
      this.contBoxCodes = this.contBoxCodes.map(item => {
        return item.split('&')[0]
      })
      this.switchCodes = this.switchCodes.map(item => {
        return item.split('&')[0]
      })
      this.checkItem = [];
      this.quxianList = [];
      if (this.activeTime.length == 0 || !this.activeTime) {
        this.$message.info('时间不能为空')
        return;
      }
      if (this.sort != '') {
        query = {
          substation: this.site.substation,
          pagesize: this.pagination.pagesize,
          pagenum: this.pagination.current,
          begin: this.activeTime[0].format('YYYY-MM-DD HH:mm:ss'),
          end: this.activeTime[1].format('YYYY-MM-DD HH:mm:ss'),
          contBoxCodes: this.contBoxCodes,
          switchCodes: this.switchCodes,
          sort: this.sort,
        }
      } else {
        query = {
          substation: this.site.substation,
          pagesize: this.pagination.pagesize,
          pagenum: this.pagination.current,
          begin: this.activeTime[0].format('YYYY-MM-DD HH:mm:ss'),
          end: this.activeTime[1].format('YYYY-MM-DD HH:mm:ss'),
          contBoxCodes: this.contBoxCodes,
          switchCodes: this.switchCodes,
        }
      }
      getPageList(query).then(
        res => {
          if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
            localStorage.clear();
            this.$router.push({
              path: config.loginURL
            })
          }
          if (res.success) {
            this.$message.success("列表查询成功")
          }
          this.dataSource2 = []
          this.pagination.total = res.data.total
          this.pagination.pagesize = res.data.pagesize
          this.pagination.current = res.data.pagenum
          res.data.rows.forEach((data, index) => {
            this.dataSource2.push({
              key: data.id,
              jg: data.contBox,
              kgbh: data.switchCode,
              dzsj: data.operaTime,
              fhzt: data.openCloseStr,
              zdzt: data.online,
              gdzt: data.mechaStateStr,
              qxgl: '',
              sjbg: '',
              diagFile: data.diagFile,
              color: this.colorList[index % 20]
            })
          })
        }).catch(() => {
          this.$message.info(); ("分页获取数据失败");
        });
    },
    //显示chart图
    getChart(data) {
      let that = this;
      let legend = [];
      let ydata = [];
      let xdata = [0];
      let serise = [];
      let maxLength = 0;
      // console.log(data,'data-----')
      data.forEach(item => {
        legend.push(item[0]);
        let list = []
        if (item[1].length > maxLength) {
          maxLength = item[1].length;
        }
        item[1].forEach(data => {
          list.push([`${data.time * 20 / 1000}`, data.p]);
        })
        //添加颜色
        let color = ''
        this.dataSource2.forEach(ele => {
          if (ele.key == item[1][0].id)
            color = ele.color
        })
        ydata.push(list);
        serise.push({
          name: item[0],
          data: list,
          type: 'line',
          smooth: true,
          color: color
        })
      })
      for (let i = 1; i <= maxLength; i++) {
        xdata.push(`${i * 20 / 1000}`);
      }
      let arrindex = Number(xdata[xdata.length - 1])
      let arrindex2 = Math.ceil(arrindex)
      while (arrindex < arrindex2) {
        xdata.push(`${parseFloat((arrindex + 0.02).toFixed(2))}`);
        arrindex+= 0.02;
    }

      //1.记住之前的颜色
      this.mychart = this.$echarts.init(document.getElementById('chart'));
      this.mychart.setOption({
        xAxis: {
          boundaryGap: false,
          type: 'category',
          name: 't（s）',
          nameLocation: 'end',
          nameTextStyle: {
            color: "#fff",
            verticalAlign: 'bottom',
            fontSize: that.rate * 12,
          },
          axisLine: {
            lineStyle: {
              color: '#16b2b4'
            }
          },
          splitLine: {
            show: true,
            interval: 49,
            lineStyle: {
              color: '#10585A'
            }
          },
          axisLabel: {
            color: '#FFFFFF',
            fontSize: that.rate * 12,
            fontFamily: ' Microsoft YaHei, Microsoft YaHei-Regular',
            interval: 0,
            formatter: function (data) {
              // var regex = /^\d*(\.(5|0))?$/;
              //   if(regex.test(Number(data))) {
              //      return data
              //   }         
              if ((Number(data) % 1) == 0) {
                return data
              }
            }
          },
          axisTick: {
            show: true,
            interval: 9,
            inside: true,
          },
          data: xdata,
          color: "#fff"
        },
        yAxis: {
          type: 'value',
          name: 'P（W）',
          nameLocation: 'end',
          nameTextStyle: {
            color: "#fff",
            fontSize: that.rate * 12,
          },
          axisLine: {
            show: true,
            nameTextStyle: {
              color: "#fff"
            },
            lineStyle: {
              color: '#16b2b4'
            }
          },
          //分隔线
          splitLine: {
            lineStyle: {
              color: '#10585A',
            }
          },
          axisLabel: {
            color: '#FFFFFF',
            fontSize: that.rate * 12,
            fontFamily: ' Microsoft YaHei, Microsoft YaHei-Regular',
          }
        },
        dataZoom: [{
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          enf: 100,
        },
        {
          type: 'inside',
          yAxisIndex: 0,
          start: 0,
          enf: 100,
        },
        {
          type: 'slider',
          show: true,
          yAxisIndex: [0],
          left: '1%',
          start: 0,
          end: 100,
          textStyle: {
            color: '#fff'
          }
        },
        ],
        grid: {
          // top: "50px",
          // left: "50px",
          // right: "70px",
          // bottom: "100px",
          // containLabel: true,
          top: "50px",
          left: "100px",
          right: "70px",
          bottom: "100px",
                borderWidth: 1,
                z: 99999,
                borderColor: '16b2b4',
                show: true,
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          backgroundColor: 'rgba(117,143,150,0.5)',
          borderColor: 'transparent',
          textStyle: {
            color: '#fff'
          }
        },
        legend: {
          data: legend,
          icon: "react",
          itemHeight: 2,
          left: 'center',
          bottom: 15,
          textStyle: {
            color: '#fff',
            fontFamily: ' Microsoft YaHei, Microsoft YaHei-Regular',
            fontSize: that.rate * 12,
            rich: {
              jg: {
                fontSize: that.rate * 12,
                width: that.rate * 12 * 34,
                lineHeight: that.rate * 16
              },
              jg2: {
                fontSize: that.rate * 12,
                width: that.rate * 12 * 24,
                lineHeight: that.rate * 16
              },
            }
          },
          formatter: function (name) {
            let str = '';
            for (let i = 0; i < legend.length; i++) {
              str = name.split(' ');
              let nameStr = `${str[0]}    ${str[1]}   ${str[2]} ${str[3]}`
              if (str[0].length > 20) {
                str[0] = str[0].slice(0, 19) + '...'
                return '{jg|' + nameStr + '}';
              }
              else if (str[0].length > 10 && str[0].length <= 20) {
                return '{jg|' + nameStr + '}'
              }
              else if (str[0].length <= 10) {
                return '{jg2|' + nameStr + '}'
              }
            }

          },
        },
        series: serise,
        //  
      })
    },
    // 表格样式（斑马）
    rowClassName(_record, index) {
      return index % 2 === 0 ? 'table-striped' : null;
    },
    // 获取当前的日期
    getTime() {
      let now = new Date();
      let a = new Array("日", "一", "二", "三", "四", "五", "六");
      let week = now.getDay();
      let str = "星期" + a[week];
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let days = now.getDate();
      days = days < 10 ? "0" + days : days;
      this.newTime = year + "-" + month + "-" + days;
      this.week = str;
      //初始时间

      let startTime = dayjs(`${year}-${month}-01 00:00:00`)
      let endTime = startTime.add(1, "M")
      this.activeTime = [startTime, endTime]
    },
    //时间控件
    changeRange(dates) {
      if (!dates || dates.length == 0) {
        this.activeTime = [];
        return;
      }
      this.activeTime[0] = dates[0];
      this.activeTime[1] = dates[1];
    },
    //获取chart图的数据
    getChartData() {
      if (this.quxianList.length == 0 || !this.quxianList) {
        this.$message.info('需要先选择想要查看的曲线')
        return;
      }
      let data = [];
      this.quxianList.forEach(item => {
        if (item) {
          data.push(item);
        }
      })
      powerCurve(data.join(',')).then(res => {
        if (res.info == "token不正确!" || res.info == "token已过期,请重新获取!") {
          localStorage.clear();
          this.$router.push({
            path: config.loginURL
          })
        }
        //  let chartData = []
        let times = []
        let orderData = []
        // let chartData = Object.entries(res.data);
        // console.log(res.data,'res.data')
        //通过时间戳排序
        for (let key in res.data) {
          let timeList = key.split(' ')
          times.push(new Date(timeList[timeList.length - 2] + ' ' + timeList[timeList.length - 1]).getTime())
        }
        let len = times.length
        for (let i = 0; i < len; i++) {
          let small = times[i]
          let index = i
          for (let j = i + 1; j < len; j++) {
            if (small > times[j]) {
              small = times[j]
              index = j
            }
          }
          if (index != i) {
            let temp = times[index]
            times[index] = times[i]
            times[i] = temp
          }
        }
        //
        for (let i = 0; i < times.length; i++) {
          for (let key in res.data) {
            let timeList = key.split(' ')
            let str = new Date(timeList[timeList.length - 2] + ' ' + timeList[timeList.length - 1]).getTime()
            if (str == times[i]) {
              orderData.push([key, res.data[key]])
            }
          }
        }
        // console.log(orderData,'orderData')
        // console.log(chartData,'chartData')
        this.showChart(orderData)
      }).catch(() => {
        this.$message.info("曲线信息获取失败");
      });
    },
    //显示echart弹窗
    showChart(data) {
      this.isShowPhoto = true;
      setTimeout(() => {
        this.getChart(data)
      }, 1000)
    },
    //关闭echart弹窗
    closeChart() {
      this.mychart.dispose();
      this.mychart = null;
      this.isShowPhoto = false;
    },
    //echart曲线选择
    showList(e) {
      //1.添加
      let newList = this.quxianList;
      if (e.length == 0) {
        for (let i = 0; i < newList.length; i++) {
          let flag = false;
          for (let j = 0; j < this.checkItem.length; j++) {
            if (newList[i] == this.checkItem[j]) {
              flag = true;
              break
            }
          }
          if (flag == false) {
            newList.splice(i, 1);
            this.quxianList = newList;
            return;
          }
        }
      }
      else {
        if (newList.length == 5) {
          this.$message.info('最多可选择5条')
          let checkList = this.checkItem;
          for (let i = 0; i < checkList.length; i++) {
            if (!checkList[i]) continue;
            if (checkList[i][0] == e[0]) {
              checkList[i] = [];
              return;
            }
          }
          this.checkItem = checkList;
        }
        this.quxianList.push(e[0]);
      }
    },
    //不显示弹窗
    closeBox() {
      this.isLeave = false;
    },
    //界面重新定义大小
    onWidnowResize() {
      let content = this.$refs.content.clientHeight - 90 - 64;
      this.heightWidth = content;
      let container = document.querySelector('.ant-table-body');
      container.style.height = content + 'px';
      this.rate = window.screen.width / 1920;
    },
  }
}
</script>

<style scoped >
.index_main {
  /* display: flex; */
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.center {
  padding: 0 10px 0 10px;
}

.bottom_content {
  height: calc(100% - 90px - 74px - 90px);
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 0 10px 0 10px;
  margin-top: 10px;
}

.info {
  height: 80px;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border: 1px solid #19889B;
  background-color: #000614;
  box-shadow: inset 0px 0px 25px 3px #0376ac;

}

.info_left {
  width: 58%;
  display: flex;
  align-items: center;
  /* padding-top : 0.4vw; */
}

.info_item {
  display: flex;
  align-items: center;
  gap: 15px;
}

.info_text {
  display: inline-block;
  /* width :100px;
    border:1px solid #19889B; */
  margin-right: 6px;
  font-size: 1.5vw;
  line-height: 1.2;
  font-family: DIN, DIN-Medium;
  font-weight: 500;
  color: #59fddf;
  /* background-color: #304353; */
  padding: 0 0 0 4px;
}

.head_icon {
  /* margin-top:5px; */
  width: 1.8vw;
}

.info_lt,
.info_rb,
.info_rt,
.info_lb {
  position: absolute;
  z-index: 100;
}

.info_lt {
  top: 1px;
  left: 1px;
}

.info_rb {
  bottom: 1px;
  right: 1px;
}

.info_rt {
  top: 1px;
  right: 1px;
}

.info_lb {
  bottom: 1px;
  left: 1px;
}

.info_right {
  display: flex;
  /* width: 25%; */
  align-items: center;
  justify-content: space-between;
}

.head_text {
  font-size: 1vw;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-align: left;
  color: #ffffff;
  display: flex;
  align-items: center;
}

.btn {
  margin-right: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  line-height: 14px;
  background: linear-gradient(-45deg, #0c96b1 0%, #0fbca1 100%);
  border: 1px solid;
  border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
}

.fenge {
  flex: 1;
  /* width: 6%; */
  text-align: center;
}

.content_sider {
  /* max-width: 350px !important;
    min-width: 330px !important; */
  height: 100%;
  width: 350px !important;
  overflow: hidden;
  /* max-height: 100%;
    min-height: 100%; */
  /* resize: both;
    overflow: hidden; */
  flex: none !important;
  margin-right: 10px;
}

.content_left {
  border: 1px solid;
  border-image: linear-gradient(0deg, #3f83a8 0%, #2b76a1 100%) 1 1;
  height: 100%;
}

.statusIcon {
  position: absolute;
  right: 10%;
  top: 50%;
  transform: translateY(-50%);
}

.main_content {
  width: calc(100% - 360px);
  border: 2px solid;
  border-image: linear-gradient(0deg, #375E79 0%, #2b76a1 100%) 1 1;
  /* flex: 1; */
}

.content_right {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  background: linear-gradient(-31deg, #3A5E78 0%, #15273F 100%);
}

.time_query {
  position: absolute;
  top: 1%;
  left: 1%;
  padding: 12px 0 12px 12px;
  z-index: 50;
}

.query_text {
  color: #ffffff;
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  margin-right: 10px;
}

.status_icon {
  color: #ffffff;
  position: absolute;
  bottom: 20px;
  left: 20px;
  vertical-align: middle;
}

.footer {
  height: 64px;
  display: flex;
  justify-content: space-between;
  text-align: center;
  background: url("../../style/img/bottom.png") no-repeat;
  background-size: 100% 100%;
  font-size: 0.8vw;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  margin: 10px 10px 0 10px;
  padding: 0 10px;
  align-items: center;
}

.index_top {
  width: 100%;
  height: 80px;
  /* display: flex;
    justify-content: space-between;
    align-items: center; */
  padding: 0 10px;
  margin: 0 0px 10px 0px;
}

.choose_type {
  display: flex;
  align-items: center;
  padding: 0 10px;
  gap: 20px;
  width: 100%;
  height: 100%;
  background: linear-gradient(144deg, #25404e 0%, #2f5c74 100%);
  border: 2px solid #2b76a1;
}

.choose_type .choose_label {
  font-size: 14px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  margin-right: 10px;
}

.showPicture {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40%;
  transform: translate(-50%, -50%);
  z-index: 100;
  border: 1px solid #2b76a1;
  background: linear-gradient(#15273f 0%, #1d3c52 100%);

}

.layout_main {
  display: flex;
  flex-direction: column;
  gap: 10px
}

.layout_head {
  background: url('../../style/img/弹窗头.png') no-repeat;
  background-position: center;
  height: 42px;
  font-size: 1vw;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.layout_picture {
  flex: 1;
  padding: 20px;
  display: flex;
  align-content: center;
  justify-content: center;
}

.layout_picture a {
  display: flex;
  justify-content: center;
  align-content: center;
}

.pictureStyle {
  width: 80%;
  background-color: #ffffff;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 200;
  width: 2.4vw;
}


.chartPhoto {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 900px;
  height: 64%;
  background: linear-gradient(#15273f 0%, #1d3c52 100%);
  border: 1px solid #2b76a1;
  z-index: 100;
  display: flex;
  flex-direction: column;
}

.chart_head {
  background: url('../../style/img/弹窗头.png') no-repeat;
  background-position: center;
  height: 42px;
  margin-bottom: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.chartStyle {
  flex: 1;
}

.chart_bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #1f1f1f79;
  z-index: 80;
}
.tableStyle {
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, #1299A2 0%, #20B0BD 100%) 1 1;
  /* border-top:none; */
}
.tableStyle ::v-deep .ant-table-body {
  border-bottom: none;
}
.tableStyle ::v-deep .ant-table-thead > tr > th {
  height: 30px;
}
.tableStyle ::v-deep thead.ant-table-thead {
  background: transparent;
}
.tableStyle ::v-deep .ant-table-thead > tr > th:not(:nth-child(8)):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  display: none;
}
/* .tableStyle ::v-deep .ant-table.ant-table-bordered > .ant-table-container { 
  border-image: linear-gradient(to right, #1299A2 0%, #20B0BD 100%) 1 1 !important;
} */
.tableStyle ::v-deep .ant-table.ant-table-bordered >.ant-table-container >.ant-table-header > table > thead > tr > th,
.tableStyle ::v-deep .ant-table.ant-table-bordered > .ant-table-container > .ant-table-body > table > tbody > tr > td,
.tableStyle ::v-deep .ant-table.ant-table-bordered > .ant-table-container > .ant-table-content > table, 
.tableStyle ::v-deep .ant-table.ant-table-bordered > .ant-table-container > .ant-table-header > table,
.tableStyle ::v-deep .ant-table.ant-table-bordered > .ant-table-container {
  border-image: linear-gradient(to right, #1299A2 0%, #20B0BD 100%) 1 1 !important;
} 

.serveStyle::v-deep.ant-input[disabled] {
  color:rgba(255, 255, 255, 0.5) !important;
}
</style>
<style>
.ant-select-tree .ant-select-tree-node-content-wrapper {
  white-space: nowrap;
  overflow: hidden;
  display: block;
  width: calc(100% - 30px);
  height: 20px;
  text-overflow: ellipsis;
}</style>
  